<template>
<div>
    <ul>
        <li class="ticket-label"
            :class="{'active-label':activeTab === 1}"
            data-tab="panel-1 open"
            @click="activeTab = 1">
            {{$t('ticket')}}
            <span class="ticket-counter" v-show="numberOfTickets > 0">{{numberOfTickets}}</span>
        </li>
        <li class="ticket-label"
            :class="{'active-label':activeTab === 2}"
            data-tab="panel-2"
            @click="activeTab = 2">
            {{$t('active_bets_small')}}
            <span class="ticket-counter" v-show="numberOfActiveTickets > 0">{{numberOfActiveTickets}}</span>
        </li>
    </ul>

    <!-- Inner wrapper for tab panels -->
    <div class="a-vs-inner-tab-wrap">
    <!-- Single tab panel -->
        <div id="panel-1" class="a-vs-ticket-panel" :class="{'active-panel':activeTab === 1}">
            <!-- Single tab panel body (actual bets) -->
            <vdog-bet-placing v-if="config != null" class="a-vg-aside--bet-placing"
                :activeStake="activeStake"
                :isBettingEnabled="isBettingEnabled"
                :roundNo="roundNo"
                :isMobileDesign="true"
                :amount="amount"
                :config="config"/>
        </div>

        <!-- Single tab panel -->
        <div id="panel-2" class="a-vs-ticket-panel" :class="{'active-panel':activeTab === 2}">
            <!-- Single tab panel body (actual bets) -->
            <vdog-played-tickets :currency = "currency"/>
        </div>
    </div>
</div>
</template>

<script>
import VDogBetPlacing from '@/components/grayhound/bet-placing/VDogBetPlacing.vue'
import VDogPlayedTickets from '@/components/grayhound/ticket/VDogPlayedTickets.vue'

export default {
  components: {
    'vdog-bet-placing': VDogBetPlacing,
    'vdog-played-tickets': VDogPlayedTickets
  },
  props: {
    numberOfTickets: Number,
    numberOfActiveTickets: Number,
    config: {
      type: Object,
      required: true
    },
    activeStake: {
      type: Object
    },
    isBettingEnabled: {
      type: Boolean
    },
    currency: {
      type: String
    },
    roundNo: {
      type: Number
    },
    amount: {
      type: Number
    }
  },
  data () {
    return {
      activeTab: 1
    }
  }
}
</script>
